



import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DictForm from './dict-form.vue';
@Component({
  components: { DictForm }
})
export default class DictEdit extends mixins(BaseFormMixin) {}
